import React, { FC } from "react";
import { InvoiceFormItemWrapper } from "@inv/components/InvoiceForm/components/InvoiceFormItemWrapper";
import { InvoiceFormBlocksTranslate, InvoiceFormInputTranslate, InvoiceInputs, TInvoicesValues } from "@inv/types";
import { FormattedMessage, useIntl } from "react-intl";
import { Flex, Form } from "antd";
import { InvoiceCurrencySelect } from "@inv/components/InvoiceFormLineItemsTable/components/InvoiceCurrencySelect";
import InvoiceLineItemsTable from "invoicing/components/InvoiceFormLineItemsTable";
import { Tab, Tabs } from "@heroui/react";

export const LineItemsBlock: FC = () => {
    const intl = useIntl();
    const form = Form.useFormInstance<TInvoicesValues>();
    const isTaxIncluded = Form.useWatch(InvoiceInputs.IS_TAX_INCLUDED, form);
    return (
        <InvoiceFormItemWrapper title={intl.formatMessage({ id: InvoiceFormBlocksTranslate.LINE_ITEMS })}>
            <Flex style={{ width: "100%", marginBottom: 20 }} align="center" justify="space-between">
                <Form.Item name={InvoiceInputs.CURRENCY_CODE} style={{ marginBottom: "0" }}>
                    <InvoiceCurrencySelect />
                </Form.Item>
                <Form.Item name={InvoiceInputs.IS_TAX_INCLUDED} style={{ marginBottom: "0" }}>
                    <Tabs
                        aria-label="Brutto Netto Mode"
                        selectedKey={(isTaxIncluded ?? false).toString()}
                        onSelectionChange={(key: string) =>
                            form.setFieldsValue({ [InvoiceInputs.IS_TAX_INCLUDED]: key === "true" })
                        }
                    >
                        <Tab key={"true"} title={<FormattedMessage id={InvoiceFormInputTranslate.MODE_BRUTTO} />} />
                        <Tab key={"false"} title={<FormattedMessage id={InvoiceFormInputTranslate.MODE_NETTO} />} />
                    </Tabs>
                </Form.Item>
            </Flex>
            <Form.Item name={InvoiceInputs.LINE_ITEMS}>
                <InvoiceLineItemsTable />
            </Form.Item>
        </InvoiceFormItemWrapper>
    );
};
